<div class="container py-4">
  <div class="row justify-content-center">
    <div class="col-md-6 col-lg-5"> <!-- controla el ancho -->
      <div class="card shadow-sm border-0">
        <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
          <h4 class="mb-0">
            <i class="fa-solid fa-user-plus me-2"></i>Alta de Nuevo Cliente
          </h4>
          <button class="btn btn-light btn-sm" (click)="volverAtras()">
            <i class="fa-solid fa-arrow-left"></i> Volver
          </button>
        </div>

        <div class="card-body">
          <form #clienteForm="ngForm" (ngSubmit)="guardarCliente()">
            <!-- Nombre -->
            <div class="mb-3">
              <label for="nombre" class="form-label">Nombre del Cliente</label>
              <div class="input-group">
                <span class="input-group-text"><i class="fa-solid fa-user"></i></span>
                <input
                  type="text"
                  id="nombre"
                  class="form-control"
                  [(ngModel)]="cliente.nombre"
                  name="nombre"
                  required
                  minlength="3"
                />
              </div>
              <div *ngIf="clienteForm.submitted && clienteForm.controls['nombre']?.invalid" class="text-danger mt-1">
                El nombre es obligatorio y debe tener al menos 3 caracteres.
              </div>
            </div>

            <!-- Teléfono -->
            <div class="mb-3">
              <label for="telefono" class="form-label">Teléfono Celular</label>
              <div class="input-group">
                <span class="input-group-text"><i class="fa-solid fa-phone"></i></span>
                <input
                  type="tel"
                  id="telefono"
                  class="form-control"
                  [(ngModel)]="cliente.telefono"
                  name="telefono"
                  required
                  pattern="^[0-9]{10}$"
                />
              </div>
              <div *ngIf="clienteForm.submitted && clienteForm.controls['telefono']?.invalid" class="text-danger mt-1">
                El teléfono debe ser un número válido de 10 dígitos.
              </div>
            </div>

            <!-- Email -->
            <div class="mb-3">
              <label for="email" class="form-label">Email</label>
              <div class="input-group">
                <span class="input-group-text"><i class="fa-solid fa-envelope"></i></span>
                <input
                  type="email"
                  id="email"
                  class="form-control"
                  [(ngModel)]="cliente.email"
                  name="email"
                  required
                  pattern="^[^@]+@[^@]+\.[a-zA-Z]{2,}$"
                />
              </div>
              <div *ngIf="clienteForm.submitted && clienteForm.controls['email']?.invalid" class="text-danger mt-1">
                El email es incorrecto.
              </div>
            </div>

            <!-- Botón guardar -->
            <div class="d-grid">
              <button type="submit" class="btn btn-success" [disabled]="!clienteForm.valid">
                <i class="fa-solid fa-check me-2"></i>Guardar Cliente
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
